import FullScreenPlayer from './FullScreenPlayer';

export default FullScreenPlayer;
